import { Component, OnInit } from '@angular/core';
import { FirebaseService } from '../services/firebase.service';
import { CustomerDataService } from '../services/customer-data.service';
import { solarConfigSheets, windConfigSheets } from '../services/utils';
import * as moment from 'moment';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit {
  logs: any[] = [];
  companiesData = []
  configSheets = [...windConfigSheets, ...solarConfigSheets];
  customerNames: any = {};
  siteNames: any = {};
  customersById: any = {}
  lastInResponse = null;
  disableNext = false;
  constructor(private firebase: FirebaseService, private cdService: CustomerDataService) {

  }
  ngOnInit(): void {
    this.cdService.message.subscribe(data => {
      this.companiesData = data
    })

    this.init();

    /* this.firebase.getCustomerConfig().then((res) => {
      this.customersById = res;
      console.log(res, 'getCustomerConfig res');
    })
    console.log('logs'); */

  }
  async init() {
    try {
      this.customersById = await this.firebase.getCustomerConfig()
      this.logs = [];
      this.getMoreLogs()
      /* this.firebase.getAuditLogs().subscribe({
        next: (res) => {
          if (res && res.length) {
            this.logs = res.map((log) => this.formatLog(log));
          }
        }
      }) */
    } catch (e) {
      console.log(e, 'error in getting logs')
    }

  }
  async getMoreLogs() {
    const auditLogsPaginated: any = await this.firebase.getAuditLogsPaginated(this.lastInResponse);
    //console.log(auditLogsPaginated, 'auditLogsPaginated')
    if (auditLogsPaginated) {
      const { logs, disableNext, lastInResponse } = auditLogsPaginated;
      console.log(auditLogsPaginated, 'auditLogsPaginated')
      this.disableNext = disableNext;
      this.lastInResponse = lastInResponse
      if (logs && logs.length) {
        this.logs = [...this.logs, ...logs.map((log: any) => this.formatLog(log))];
      }
      /* console.log(logs, 'new logs')
      console.log(this.logs, 'this.logs') */
    }
  }
  formatLog(data: any) {
    let message = '';
    switch (data.type) {
      case 'validate-sheet':
        message = 'Validated ';
        const sheet = this.configSheets.find(s => s.id === data?.meta?.sheet);
        if (sheet) {
          message += ' ' + sheet.name;
        }
        message += ' sheet';
        break
      case 'update-site':
        message = 'Updated Config'
        break;
      case 'create-site':
        message = 'Created Site'
        break
      case 'create-customer':
        message = 'Created Customer'
        break;
    }
    const c = this.getCustomerName(data.customer);
    const s = this.getSiteName(data.customer, data.id);
    const dateTimte = moment(data.time).format("YYYY-MMM-DD HH:mm:ss");
    const siteString = data.type !== 'create-customer' ? `(${s})` : '';
    const rightString = `<b>${c}${siteString} : </b>${message}`
    const log = {
      name: data.by,
      c,
      s,
      time: data.time,
      m: message,
      type: data.type,
      leftString: `${dateTimte}<br>${data.by}`,
      rightString,
    };
    return log;

    /* Dummy(s1) : Updated sheet Master
sai@digitised(time) */

  }
  getCustomerName(id: string) {
    if (this.customerNames[id]) {
      return this.customerNames[id]
    } else {
      const companyData: any = this.companiesData.find((c: any) => c.id === id);
      if (companyData) {
        this.customerNames[id] = companyData.name;
      } else {
        this.customerNames[id] = id;
      }
      return this.customerNames[id]
    }
  }
  getSiteName(cId: string, id: string) {
    if (this.siteNames[cId] && this.siteNames[cId][id]) {
      return this.siteNames[cId][id];
    } else {
      if (!this.siteNames[cId]) {
        this.siteNames[cId] = {};
      }
      const companyData: any = this.customersById[cId];
      if (companyData && companyData[id] && companyData[id].static_data && companyData[id].static_data.name && companyData[id].static_data.name.value) {
        this.siteNames[cId][id] = companyData[id].static_data.name.value;
      } else {
        this.siteNames[cId][id] = id;
      }
      return this.siteNames[cId][id];
    }
  }
  /* async getSitesConfigs(cId: string) {
    if (this.customersById[cId]) {
      return this.customersById[cId];
    } else {
      const customerData = await this.firebase.getSitesConfigs(cId);
      if (customerData) {
        this.customersById[cId] = customerData;
      }
      return this.customersById[cId];
    }
  } */
}
